(function($) {

	$.fn.redirect = function() {

		var elem = $(this),
			settings = {
				url: '/',
				timeout: 10000
			};

		var init = function() {

            // Parse settings
            settings = $.extend(true, {}, settings, elem.parseSettings());

			if(settings.url) {

				// If refresh request just set the url as current location
				if(settings.url == 'refresh') {
					settings.url = window.location.href;
				}

				// Set a timeout and redirect the user
				setTimeout(function() {
					window.location.href = settings.url;
				}, settings.timeout);
			}
		};

		init();
		return this;
	};

}($));